<template>
  <div class="modal fade nested-modal" id="PricesModal" tabindex="-1" aria-labelledby="PricesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="PricesModalLabel">Tabela de Preços</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-info mb-4">
            <strong>Nota:</strong> O valor da sua fatura será calculado automaticamente conforme o seu consumo com relação aos valores abaixo.
          </div>
          
          <div v-if="!getPrices || Object.keys(getPrices).length === 0" class="text-center p-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
            <p class="mt-3">Carregando tabela de preços...</p>
          </div>
          
          <div v-else class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Período de Armazenamento</th>
                  <th class="text-end">Preço (R$/mês)</th>
                </tr>
              </thead>
              <tbody>
                <!-- SD -->
                <template v-if="getPrices.SD">
                  <tr v-for="(price, days) in getSortedPrices('SD')" :key="`sd-${days}`">
                    <td>
                      <span class="badge bg-secondary">SD</span>
                      <span class="ms-2">Standard Definition</span>
                    </td>
                    <td>
                      <span v-if="days === '0'">Sem gravação</span>
                      <span v-else-if="days === '1'">1 dia</span>
                      <span v-else>{{ days }} dias</span>
                    </td>
                    <td class="text-end">R$ {{ formatPrice(price) }}</td>
                  </tr>
                </template>
                
                <!-- HD -->
                <template v-if="getPrices.HD">
                  <tr v-for="(price, days) in getSortedPrices('HD')" :key="`hd-${days}`">
                    <td>
                      <span class="badge bg-primary">HD</span>
                      <span class="ms-2">High Definition</span>
                    </td>
                    <td>
                      <span v-if="days === '0'">Sem gravação</span>
                      <span v-else-if="days === '1'">1 dia</span>
                      <span v-else>{{ days }} dias</span>
                    </td>
                    <td class="text-end">R$ {{ formatPrice(price) }}</td>
                  </tr>
                </template>
                
                <!-- FULLHD -->
                <template v-if="getPrices.FULLHD">
                  <tr v-for="(price, days) in getSortedPrices('FULLHD')" :key="`fullhd-${days}`">
                    <td>
                      <span class="badge bg-success">FULL HD</span>
                      <span class="ms-2">Full High Definition</span>
                    </td>
                    <td>
                      <span v-if="days === '0'">Sem gravação</span>
                      <span v-else-if="days === '1'">1 dia</span>
                      <span v-else>{{ days }} dias</span>
                    </td>
                    <td class="text-end">R$ {{ formatPrice(price) }}</td>
                  </tr>
                </template>
                
                <!-- 2K -->
                <template v-if="getPrices['2K']">
                  <tr v-for="(price, days) in getSortedPrices('2K')" :key="`2k-${days}`">
                    <td>
                      <span class="badge bg-warning text-dark">2K</span>
                      <span class="ms-2">2K Resolution</span>
                    </td>
                    <td>
                      <span v-if="days === '0'">Sem gravação</span>
                      <span v-else-if="days === '1'">1 dia</span>
                      <span v-else>{{ days }} dias</span>
                    </td>
                    <td class="text-end">R$ {{ formatPrice(price) }}</td>
                  </tr>
                </template>
                
                <!-- 4K -->
                <template v-if="getPrices['4K']">
                  <tr v-for="(price, days) in getSortedPrices('4K')" :key="`4k-${days}`">
                    <td>
                      <span class="badge bg-danger">4K</span>
                      <span class="ms-2">Ultra HD/4K</span>
                    </td>
                    <td>
                      <span v-if="days === '0'">Sem gravação</span>
                      <span v-else-if="days === '1'">1 dia</span>
                      <span v-else>{{ days }} dias</span>
                    </td>
                    <td class="text-end">R$ {{ formatPrice(price) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as bootstrap from 'bootstrap';

export default {
  name: "PricesModal",
  mounted() {
    this.setPrices();
    this.setupNestedModal();
  },
  methods: {
    ...mapActions([
      "setPrices"
    ]),
    setupNestedModal() {
      // Ajustar o modal para trabalhar com outro modal aberto
      const pricesModalEl = document.getElementById('PricesModal');
      
      if (pricesModalEl) {
        new bootstrap.Modal(pricesModalEl, {
          backdrop: false
        });
        
        // Sobrescreve o evento de abertura para manter a funcionalidade
        pricesModalEl.addEventListener('show.bs.modal', () => {
          // Quando abrir, adicionar classe para styling especial
          document.body.classList.add('has-nested-modal');
          pricesModalEl.style.zIndex = 1056; // Um valor acima do modal padrão (1055)
        });
        
        // Sobrescreve o evento de fechamento
        pricesModalEl.addEventListener('hidden.bs.modal', () => {
          // Quando fechar, restaurar o estilo do body
          document.body.classList.remove('has-nested-modal');
        });
      }
    },
    formatPrice(price) {
      return Number(price).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    getSortedPrices(category) {
      if (!this.getPrices || !this.getPrices[category]) {
        return {};
      }
      
      const prices = this.getPrices[category];
      
      // Retorna os preços ordenados por número de dias (período)
      return Object.keys(prices)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .reduce((obj, key) => {
          obj[key] = prices[key];
          return obj;
        }, {});
    }
  },
  computed: {
    ...mapGetters([
      "getPrices"
    ])
  }
};
</script>

<style>
/* Estilos globais para lidar com o modal aninhado */
body.has-nested-modal .modal-backdrop:nth-child(2) {
  opacity: 0.2 !important;
}

body.has-nested-modal .modal.nested-modal {
  background-color: rgba(0, 0, 0, 0.2);
}

.modal.nested-modal {
  z-index: 1056 !important;
}
</style>

<style scoped>
.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.badge {
  min-width: 50px;
  padding: 5px 10px;
}
</style> 